import axios from "axios";
import apiEndpoint from "./api";

var header = {};
const user = JSON.parse(localStorage.getItem("user"));
if (user && user.data.token) {
  header = {
    Authorization: "Bearer " + user.data.token,
    "Content-type": "application/json",
  };
} else {
  header = {
    "Content-type": "application/json",
  };
}
export default axios.create({
  // baseURL: "http://localhost:5001/api",
  baseURL: apiEndpoint,
  headers: {
    ...header,
  },
});
